import { ActivityIndicator, View } from 'react-native';
import { Outlet, Navigate, createFileRoute } from '@tanstack/react-router';
import { db } from '@/lib/db/instant';
import { useCompounds } from '@/lib/state/compounds';
import { BottomTabBar } from '@/components/BottomTabBar';

export const Route = createFileRoute('/_tabs')({
  component: TabsLayout,
});

function TabsLayout() {
  const { isLoading: authLoading, user } = db.useAuth();
  const { userCompounds, loading: dataLoading } = useCompounds();

  if (authLoading) {
    return (
      <View className="flex-1 items-center justify-center bg-bg">
        <ActivityIndicator color="#FF5A1F" />
      </View>
    );
  }
  if (!user) return <Navigate to="/sign-in" />;
  if (dataLoading) {
    return (
      <View className="flex-1 items-center justify-center bg-bg">
        <ActivityIndicator color="#FF5A1F" />
      </View>
    );
  }
  if (userCompounds.length === 0) return <Navigate to="/onboarding" />;

  return (
    <View className="flex-1 bg-bg">
      <View className="flex-1">
        <Outlet />
      </View>
      <BottomTabBar />
    </View>
  );
}
